"use strict";

var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");
var cx = require("classnames");

var ButtonGroup = React.createClass({
  propTypes: {
    children: React.PropTypes.node.isRequired,
    className: React.PropTypes.string
  },
  render: function() {
    let classes = cx(this.props.className, "btn-group")

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
});

module.exports = ButtonGroup;



// WEBPACK FOOTER //
// ./app/shared/components/ButtonGroup/button-group.jsx